import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconTriangleDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M19.0335 7.12843C19.3257 6.62844 18.9651 6 18.386 6L5.61401 6C5.03489 6 4.67427 6.62844 4.96648 7.12842L11.2661 17.9079C11.5943 18.4693 12.4057 18.4693 12.7339 17.9079L19.0335 7.12843ZM18.386 4.5C20.1233 4.5 21.2052 6.38531 20.3286 7.88528L14.0289 18.6647C13.1217 20.2171 10.8783 20.2171 9.97108 18.6647L3.67142 7.88528C2.79481 6.38531 3.87667 4.5 5.61401 4.5L18.386 4.5Z",
		fill: "currentColor"
	})
});
export { SvgIconTriangleDown as ReactComponent };
